"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WMPStates = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _get = _interopRequireDefault(require("lodash/get"));
var _Player2 = _interopRequireDefault(require("../models/Player"));
var _percentageToTime = _interopRequireDefault(require("../utils/percentageToTime"));
var _htmlMediaEvents = _interopRequireDefault(require("../constants/htmlMediaEvents"));
var _getElapsedPercent = _interopRequireDefault(require("../utils/getElapsedPercent"));
var _playerName = _interopRequireDefault(require("../constants/playerName"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-underscore-dangle */
var WMPStateMonitorInterval = 500;
var WMPBufferingTimeout = 5000;

/**
 * Windows Media Player play states that are returned from the Player.playState
 * property.
 *
 * Documentation:
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/player-playstate
 *
 * @type {{
 * reconnecting: number,
 * stopped: number,
 * paused: number,
 * waiting: number,
 * transitioning: number,
 * scanForward: number,
 * ready: number,
 * buffering: number,
 * mediaEnded: number,
 * playing: number,
 * scanReverse: number
 * }}
 */
var WMPStates = exports.WMPStates = {
  stopped: 1,
  paused: 2,
  playing: 3,
  scanForward: 4,
  scanReverse: 5,
  buffering: 6,
  waiting: 7,
  mediaEnded: 8,
  transitioning: 9,
  ready: 10,
  reconnecting: 11
};
var WMPStatesToHTMLMediaEvents = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, WMPStates.stopped, _htmlMediaEvents["default"].stopped), WMPStates.paused, _htmlMediaEvents["default"].paused), WMPStates.playing, _htmlMediaEvents["default"].playing), WMPStates.scanForward, _htmlMediaEvents["default"].seeked), WMPStates.scanReverse, _htmlMediaEvents["default"].seeked), WMPStates.buffering, _htmlMediaEvents["default"].progress), WMPStates.waiting, _htmlMediaEvents["default"].waiting), WMPStates.reconnecting, _htmlMediaEvents["default"].waiting), WMPStates.mediaEnded, _htmlMediaEvents["default"].ended);

/**
 * We are only supporting Windows Media Player version 7 and above. The format
 * of the version string returned from WMP is: "X.0.0.YYYY - where X represents
 * the major version number and YYYY represents the build number."
 *
 * Documentation:
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/player-versioninfo
 *
 */
var CaptureWMPVersionRegex = /(\d+)\.\d+\.\d+\.\d+$/;
function isWMPVersion7orAbove(versionInfo) {
  if (!versionInfo) {
    return false;
  }
  var result = CaptureWMPVersionRegex.exec(versionInfo);
  var majorVersionPart = result && result[1];
  if (!majorVersionPart) {
    return false;
  }
  var majorVersion = parseInt(majorVersionPart, 10);
  return majorVersion >= 7;
}

/**
 * Some documentation for Windows Media Player API:
 *
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/player-object
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/controls-object
 *  https://docs.microsoft.com/en-us/windows/win32/wmp/settings-object
 */
var WindowsMediaPlayer = exports["default"] = /*#__PURE__*/function (_Player) {
  (0, _inherits2["default"])(WindowsMediaPlayer, _Player);
  function WindowsMediaPlayer(playerId, containerElement, blankMP3Url) {
    var _this;
    (0, _classCallCheck2["default"])(this, WindowsMediaPlayer);
    _this = _callSuper(this, WindowsMediaPlayer, [_playerName["default"].WindowsMediaPlayer]);
    _this.playerId = playerId;
    _this.containerElement = containerElement;
    _this.blankMP3Url = blankMP3Url;
    _this.wmp = null;
    _this.currentState = null;
    _this.currentTimes = {};
    _this.wmpStatePoller = null;
    _this._setBufferingTimeout = _this._setBufferingTimeout.bind((0, _assertThisInitialized2["default"])(_this));
    _this._evaluateWMPState = _this._evaluateWMPState.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(WindowsMediaPlayer, [{
    key: "on",
    value: function on(event, handler) {
      this.addListener(event, handler);
    }
  }, {
    key: "off",
    value: function off(event, handler) {
      this.removeListener(event, handler);
    }

    /**
     * A reference to Windows Media Player object can be accessed from the global
     * scope using the ID that was set into the Object element where the player
     * resides. (See WindowsMediaPlayerFactory.)
     *
     * Documentation (at the bottom of the page):
     *  https://docs.microsoft.com/en-us/windows/win32/wmp/player-object
     */
  }, {
    key: "init",
    value: function init() {
      var playerInstance = global[this.playerId];
      if (!playerInstance) {
        throw new Error('Could not initialize windows media player.');
      }
      var versionInfo = playerInstance.versionInfo;
      if (!isWMPVersion7orAbove(versionInfo)) {
        throw new Error('No support for WMP version < 7.');
      }
      this.wmp = playerInstance;
      this.wmp.settings.autoStart = false;
      this._pollWMPState();
    }
  }, {
    key: "load",
    value: function load(url) {
      this.wmp.url = url;
    }
  }, {
    key: "play",
    value: function () {
      var _play = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(playPosition) {
        var _this2 = this;
        var playPromise;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              playPromise = new Promise(function (resolve, reject) {
                _this2.once(_htmlMediaEvents["default"].progress, _this2._setBufferingTimeout);
                _this2.once(_htmlMediaEvents["default"].playing, resolve);
                _this2.once(_htmlMediaEvents["default"].error, reject);
                _this2.wmp.controls.play();
              });
              _context.next = 3;
              return playPromise;
            case 3:
              this.off(_htmlMediaEvents["default"].progress, this._setBufferingTimeout);
              this._clearBufferingTimeout();
              if (playPosition) {
                this.wmp.controls.currentPosition = playPosition;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function play(_x) {
        return _play.apply(this, arguments);
      }
      return play;
    }()
  }, {
    key: "seek",
    value: function seek(positionPercentage) {
      var _this$getTimes = this.getTimes(),
        duration = _this$getTimes.duration;
      this.wmp.controls.currentPosition = (0, _percentageToTime["default"])(positionPercentage, duration);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.wmp.controls.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.wmp.controls.stop();
    }
  }, {
    key: "unload",
    value: function unload() {
      this.stop();
      this.wmp.url = this.blankMP3Url;
    }

    // https://docs.microsoft.com/en-us/windows/win32/wmp/settings-isavailable
  }, {
    key: "canChangePlaybackRate",
    value: function canChangePlaybackRate() {
      return !!this.wmp.settings.isAvailable && this.wmp.settings.isAvailable('Rate');
    }

    //  https://docs.microsoft.com/en-us/windows/win32/wmp/settings-rate
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.wmp.settings.rate;
    }

    //  https://docs.microsoft.com/en-us/windows/win32/wmp/settings-rate
  }, {
    key: "changePlaybackRate",
    value: function changePlaybackRate(rate) {
      this.wmp.settings.rate = rate;
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if (!(0, _isNumber["default"])(volume)) {
        return;
      }
      this.wmp.settings.volume = volume < 1 ? volume * 100 : volume;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.wmp.settings.volume;
    }
  }, {
    key: "setTitle",
    value: function setTitle() {
      // noop
    }
  }, {
    key: "getTimes",
    value: function getTimes() {
      var elapsedSeconds = Math.floor((0, _get["default"])(this.wmp, 'controls.currentPosition', 0));
      var duration = Math.floor((0, _get["default"])(this.wmp, 'currentMedia.duration', 0));
      return {
        elapsedPercent: (0, _getElapsedPercent["default"])(elapsedSeconds, duration),
        elapsedSeconds: elapsedSeconds,
        duration: duration
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._stopPollingWMPState();
      this.unload();
      var parentElement = this.containerElement.parentElement || this.containerElement.parentNode;
      if (!parentElement) {
        return;
      }
      parentElement.removeChild(this.containerElement);
    }

    /**
     * Fix for AAC "live" streams (that do not have a set duration) on Windows 7
     * where the player hangs in the "buffering" state during the initial playback
     * request after it loads and plays the first data packet. The fix is to force
     * the media to restart by calling stop, and then immediately calling play, which
     * then updates the player state correctly to "playing".
     *
     * @private
     */
  }, {
    key: "_setBufferingTimeout",
    value: function _setBufferingTimeout() {
      var _this3 = this;
      this.bufferingTimeout = setTimeout(function () {
        if (_this3.currentState === WMPStates.buffering) {
          _this3.wmp.controls.stop();
          _this3.wmp.controls.play();
        }
      }, WMPBufferingTimeout);
    }
  }, {
    key: "_clearBufferingTimeout",
    value: function _clearBufferingTimeout() {
      clearTimeout(this.bufferingTimeout);
    }
  }, {
    key: "_pollWMPState",
    value: function _pollWMPState() {
      this.wmpStatePoller = setInterval(this._evaluateWMPState, WMPStateMonitorInterval);
    }
  }, {
    key: "_evaluateWMPState",
    value: function _evaluateWMPState() {
      var times = this.getTimes();
      if (!(0, _reactFastCompare["default"])(times, this.currentTimes)) {
        this.currentTimes = times;
        this.emit(_htmlMediaEvents["default"].timeupdate, times);
      }
      var playState = this.wmp.playState;
      if (this.currentState === playState) {
        return;
      }
      var mediaEvent = WMPStatesToHTMLMediaEvents[playState];
      if (!mediaEvent) {
        return;
      }
      this.currentState = playState;
      this.emit(mediaEvent);
    }
  }, {
    key: "_stopPollingWMPState",
    value: function _stopPollingWMPState() {
      clearInterval(this.wmpStatePoller);
    }
  }]);
  return WindowsMediaPlayer;
}(_Player2["default"]);
//# sourceMappingURL=WindowsMediaPlayer.js.map